<script>
  import { imgSrc } from '$client';
  export let data;
</script>

<li>
  <img loading="lazy" height="80" width="80" src={imgSrc(data.attributes.url)} alt={data.attributes.alternativeText} />
</li>

<style lang="scss">
  img {
    width: 100%;
    min-height: 80px;
    object-fit: contain;
    object-position: center;
    filter: grayscale(1);
  }
</style>
